export default {
    svgData: [
        {
            height: 300,
            width: 500,
        }
    ],
    cirlcesData: [{
        cx: 100,
        cy: 150,
        r: 50,
        stroke: 'black',
        strokeWidth: 1,
        fill: '#f9dbe0' // Nice red
    },
    {
        cx: 250,
        cy: 150,
        r: 50,
        stroke: 'black',
        strokeWidth: 1,
        fill: '#d1efc9' // Nice green
    }],
    pieData: [
        {age: '<20', population: '2704659'},
        {age: '20-30', population: '14106543'},
        {age: '30-40', population: '2159981'},
        {age: '40-50', population: '3853788'},
        {age: '>50', population: '4499890'},
    ]
};



// WEBPACK FOOTER //
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/src/app/data.ts